import { memo, useEffect, useState } from 'react';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import TaiKhoanService from 'src/services/TaiKhoan.service';
import { useTaiKhoan } from 'src/stores';
import { IBaseProps } from 'src/types/common.type';

const svTaiKhoan = new TaiKhoanService();

function InitAppProvider({ children }: IBaseProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const { doiTaiKhoan } = useTaiKhoan();

  useEffect(() => {
    fetchInit();
  }, []);

  const fetchInit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const account = await svTaiKhoan.thongTinCaNhan();
      doiTaiKhoan(account);
    } catch (error) {
      doiTaiKhoan(null);
      console.log(error);
    }
    setInit(true);
    setLoading(false);
  };

  if (loading || !init) return <SpinnerLoader bg={false} />;

  return children;
}

export default memo(InitAppProvider);
